import { Component, Input, OnDestroy, ElementRef, ViewChild, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../auth.service';
import { AuthState } from '../../auth-state';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { User } from '../../user';
import { Subscription } from 'rxjs';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';

declare var $: any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent extends AbstractForm implements OnDestroy{

  @ViewChild('code', {static:true}) code:ElementRef;
  @HostBinding('className') className = '';

  code_sent = false;
  code_correct = false;
  _show: boolean;
  submitted: boolean;
  private showStates = [AuthState.FORGOT_PASSWORD];

  messageSubscription:Subscription;
  message = '';

  constructor(
    protected formBuilder: FormBuilder,
    logger: LoggerService,
    protected authService: AuthService) {

      super(formBuilder, logger);

      this.messageSubscription = authService.messages$.subscribe(msg => {
        this.message = msg?.msg || '';
      });

  }

  ngOnDestroy(){
    this.messageSubscription.unsubscribe();
  }
  @Input()
  set authState(authState) {
    this._show = this.showStates.filter(item => item === authState.state).length > 0;
    if(!this._show)
      this.reset();
      
    this.className = this._show? 'active' : '';
  }

  buildFormGroup(): FormGroup {
    return this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
      code: ['', [Validators.required, Validators.minLength(6)]]
    });

  }
  updateControls() {}
  updateObject():any {}


  getUser(): User {
    const u = new User();
    u.username = this.getControlValue('username');
    u.password = this.getControlValue('password');
    u.verificationCode = this.getControlValue('code');
    return u;
  }

  reset(){
    this.code_sent = false;
    this.code_correct = false;
    if(this.formGroup?.controls){
      this.setControlValue('username', '');
      this.setControlValue('password', '');
      this.setControlValue('code', '');
    }
  }

  onSend() {
    this.message = '';
    this.authService.forgotPassword(this.getUser())
        .then((result) => { 
            this.message = 'Código de segurança '+(this.code_sent? 'reenviado' : 'enviado')+' para '+result.CodeDeliveryDetails.Destination;
            $('.codeInput').focus();
            this.code_sent = true; 
          });
  }

  onSubmit() {
    if(!this.code_sent)
      return this.onSend();

    if(this.formGroup.valid){
      this.submitted = true;
      this.authService.forgotPasswordSubmit(this.getUser())
        .then((result) => { 

          this.reset();
        })
        .catch(err => {
          if(err.code=="LimitExceededException")
            this.code_correct=true;
        })
        .finally(() => this.submitted = false);
    }
  }

  onSignIn() {
    this.authService.changeAuthState(AuthState.SIGN_IN, null);
  }
}
